import React, { useContext, useState } from 'react'
import { CreateProject } from './createProject'
import { ChooseExistingProject } from './chooseExistingProject'
import { ImportFiles } from './importFiles'
import useProjectSelection from '../../../hooks/useProjectSelection'
import { DashboardContext } from '../../../context/DashboardContext'

interface ProjectLayoutProps {
  link?: string
  importFile?: boolean
  handleClose: (...args: any[]) => void
  productId?: string
}

export function ProjectLayout({ link, importFile, handleClose, productId }: ProjectLayoutProps) {
  const {
    isNewProject,
    setIsNewProject,
    showImportDialog,
    projectId,
    projectName,
    handleGoBack,
    handleCreateProject,
    handleChooseExistingProject,
  } = useProjectSelection(link, importFile)
  const { allProjects } = useContext(DashboardContext)
  const [currentStage, setCurrentStage] = useState<'product' | 'project'>('product')
  const [selectedProduct, setSelectedProduct] = useState<{ id: string; name: string } | undefined>(undefined)

  if (showImportDialog) {
    return (
      <ImportFiles
        projectId={projectId}
        projectName={projectName}
        handleClose={handleClose}
        handleGoBack={!isNewProject && handleGoBack}
      />
    )
  }

  const getDialogTitle = () => {
    if (isNewProject) {
      return 'Add New Project'
    }
    return currentStage === 'product' ? 'Select a Product' : `Add to a Project in ${selectedProduct?.name || ''}`
  }

  const handleStageChange = (stage: 'product' | 'project', product?: { id: string; name: string }) => {
    setCurrentStage(stage)
    setSelectedProduct(product)
  }

  return (
    <div className="fixed top-0 left-0 w-full h-full bg-opacity-30 bg-black z-20" onClick={() => handleClose(true)}>
      <div
        className="absolute left-1/4 right-1/4 bg-white p-[28px] rounded-xl"
        style={{ top: '10%' }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="mb-[29px] flex items-center justify-between">
          <p className="text-zinc text-[26px] font-semibold font-['Manrope']">{getDialogTitle()}</p>
          <div className="flex items-center">
            {!!allProjects.length && (link || importFile) && currentStage === 'project' && (
              <button
                className="mr-[18px] px-4 py-2.5 rounded-[100px] shadow-inner border border-pink justify-center items-center gap-3 inline-flex"
                onClick={() => {
                  setIsNewProject(!isNewProject)
                  if (!isNewProject && selectedProduct) {
                    productId = selectedProduct.id
                  }
                }}
              >
                <p className="text-pink text-base font-semibold font-['Manrope'] leading-tight">
                  {isNewProject ? 'Add to Existing Project' : 'Add to New Project'}
                </p>
              </button>
            )}
            <button onClick={() => handleClose(true)}>
              <svg width="40" height="36" viewBox="0 0 40 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M26.8577 12L13.7158 24"
                  stroke="#40424A"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M13.7158 12L26.8577 24"
                  stroke="#40424A"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          </div>
        </div>
        {isNewProject ? (
          <CreateProject
            handleCreateProject={handleCreateProject}
            handleClose={handleClose}
            productId={selectedProduct?.id || productId}
          />
        ) : (
          <ChooseExistingProject
            handleChooseExistingProject={handleChooseExistingProject}
            onStageChange={handleStageChange}
          />
        )}
      </div>
    </div>
  )
}
